import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../../../styles';

const styles = css`
  .PageSection {
    padding: 30px 0;
    position: relative;
    z-index: 2;
    @media (min-width: 992px) {
      padding: 180px 0;
      overflow: hidden;
      background-color: ${colors.bodyLightest};
      &::before {
        content: '';
        display: block;
        position: absolute;
        background-image: linear-gradient(-45deg, rgba(0,0,0,0.5) 25%, rgba(0,0,0,0) 100%);
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 2;
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        height: 100%;
        width: 600px;
        transform: skewX(8deg);
        background-color: ${colors.black};
        left: -100px;
        right: auto;
        top: 0;
        z-index: 2;
        opacity: .25;
      }
      &:nth-child(odd) {
        background-color: ${colors.neutral};
        &::before {
          background-image: linear-gradient(45deg, rgba(255,255,255,0.6) 25%, rgba(255,255,255,0) 100%);
        }
        .PageSection_heading, .PageSection_body p, .PageSection_body li {
          color: ${colors.body};
        }
        .AlternatingElement_1 {
          order: 2;
        }
        .AlternatingElement_2 {
          order: 1;
        }
        &::after {
          right: -100px;
          left: auto;
          opacity: .04;
          transform: skewX(-8deg);
        }
      }
    }
  }
  .PageSection_media {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: relative;
    z-index: 3;
  }
  .PageSection_image {
    width: 300px;
    height: 300px;
    margin: 0 0 30px 0;
    background-size: cover;
    background-position: center center;
    border-radius: 50%;
    @media (min-width: 1200px) {
      width: 450px;
      height: 450px;
      margin: 0 0 0 0;
    }
  }
  .PageSection_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 0 10px;
    position: relative;
    z-index: 3;
    @media (min-width: 1200px) {
      padding: 0 45px;
    }
  }
  .PageSection_heading {
    font-size: 36px;
    line-height: 42px;
    font-family: ${typography.Serif};
    text-align: center;
    position: relative;
    @media (min-width: 480px) {
      font-size: 46px;
      line-height: 52px;
    }
    @media (min-width: 992px) {
      font-size: 54px;
      line-height:1.2;
      text-align: left;
      color: ${colors.white};
    }
    &::after {
      content: '';
      display: block;
      margin: 10px auto;
      width: 75px;
      height: 4px;
      background-color: ${colors.brand4};
      @media (min-width: 480px) {
        margin: 20px auto;
      }
      @media (min-width: 992px) {
        margin: 30px 0;
      }
    }
  }
  .PageSection_body {
    text-align:center;
    @media (min-width: 992px) {
      text-align:left;
    }
    p {
      @media (min-width: 992px) {
        color: ${colors.white};
      }
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0 0 30px 0;
    }
    li {
      font-size: 17px;
      line-height: 1.8;
      font-weight: 200;
      margin: 0 0 30px 0;
      font-family: ${typography.Condensed};
      @media (min-width: 992px) {
        font-size: 25px;
        color: ${colors.white};
      }
    }
  }
`;

function PageSections({ content }) {
  return (
    <div className={styles}>
      {
        (content || []).map(section => (
          <div className="PageSection" key={section.title}>
            <div className="container">
              <div className="row">
                <div className="col-lg-5 AlternatingElement_1">
                  <div className="PageSection_media">
                    <div className="PageSection_image" style={{ backgroundImage: `url(${buildThumbnailUrl(get(section, 'image.contentUrl'), { width: 600, height: 600 })})` }} />
                  </div>
                </div>
                <div className="col-lg-7 AlternatingElement_2">
                  <div className="PageSection_content">
                    {
                      section.title &&
                      <h3 className="PageSection_heading">{get(section, 'title')}</h3>
                    }
                    {
                      section.body &&
                      <div className="PageSection_body" dangerouslySetInnerHTML={SanitizeHtml(get(section, 'body'))} />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      }
    </div>
  );
}

PageSections.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object),
};

PageSections.defaultProps = {
  content: [],
};

export default PageSections;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/HomePageSections.section.js